// extracted by mini-css-extract-plugin
export var standaloneTable = "_1p-0";
export var standaloneTableWithBodyFill = "_1p-1";
export var withExtraHeader = "_1p-2";